"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COIN_PREFIX = exports.APOSTROPHE = exports.SEPARATOR = void 0;

/**
 * This module defines string constants for derivation paths.
 *
 * @module constants
 */
var SEPARATOR = "/";
exports.SEPARATOR = SEPARATOR;
var APOSTROPHE = "'";
exports.APOSTROPHE = APOSTROPHE;
var COIN_PREFIX = "m";
exports.COIN_PREFIX = COIN_PREFIX;